/**
 * Popup de dépôt d'avis maison — remplace le widget de l'app tierce.
 * Poste vers l'API du WMS ; l'avis reste TOUJOURS en attente de modération humaine,
 * jamais publié directement (voir docs/spec-avis-clients.md, dépôt YUMI-POS-Printer).
 */
(function () {
  var dialog = document.getElementById('review-submit-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var form = document.getElementById('review-submit-form');
  var statusEl = form.querySelector('[data-review-status]');
  var submitBtn = form.querySelector('[data-review-submit]');

  function openDialog() {
    form.reset();
    statusEl.textContent = '';
    statusEl.removeAttribute('data-state');
    dialog.showModal();
  }

  function closeDialog() {
    dialog.close();
  }

  document.querySelectorAll('[data-review-open]').forEach(function (btn) {
    btn.addEventListener('click', openDialog);
  });

  dialog.querySelectorAll('[data-review-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDialog);
  });

  // Light-dismiss : un clic sur le fond (::backdrop) ferme, un clic dans la boîte ne ferme pas.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeDialog();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!form.reportValidity()) return;

    var data = new FormData(form);
    var sku = dialog.dataset.reviewSku || '';
    var payload = {
      sku: sku,
      rating: Number(data.get('rating')),
      title: (data.get('title') || '').trim() || null,
      body: (data.get('body') || '').trim(),
      author_name: (data.get('author_name') || '').trim(),
      author_email: (data.get('author_email') || '').trim(),
    };

    submitBtn.disabled = true;
    statusEl.removeAttribute('data-state');
    statusEl.textContent = 'Envoi en cours…';

    fetch(window.wmsReviewsEndpoint || 'https://wms.yumi-lab.com/api/wms/reviews/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('http_' + response.status);
        return response.json();
      })
      .then(function () {
        statusEl.setAttribute('data-state', 'success');
        statusEl.textContent = 'Merci ! Votre avis sera visible après vérification.';
        setTimeout(closeDialog, 2200);
      })
      .catch(function () {
        statusEl.setAttribute('data-state', 'error');
        statusEl.textContent = "L'envoi a échoué, réessayez dans un instant.";
      })
      .finally(function () {
        submitBtn.disabled = false;
      });
  });
})();
